module.exports = __webpack_public_path__ + "img/partnership_plan_title.3e21dfa8.png";